import { ZiggyVue } from 'ziggy-js'

export default function (app) {
  app.use(ZiggyVue)
}
